import {
  Paper,
  TypographyElement,
  Button,
  ButtonVariation,
  ButtonSize,
  Icons,
  IconButton
} from 'UI'
import classNames from 'classnames'
import { useRef, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'

const useStyles = createUseStyles(style)
const imagesToShow = 6

export default ({
  scrollToPricing,
  showPopUp,
  setShowPopUp,
  showPricing,
  selectedImage,
  setSelectedImage,
  selectedProject,
  isLearningPath,
  learningPathProjects,
  handlePreviousImage,
  handleNextImage,
  handleImageClick,
  projectArray,
  setProjectArray,
  imagesArray,
  tags
}) => {
  const theme = useTheme()
  const {
    header,
    projectPictures,
    image,
    selectedImageStyle,
    gallery,
    projectText,
    arrowsContainer,
    buttonStyle,
    leftIcon,
    bigImage
  } = useStyles()
  const handleButtonPressed = ({ keyCode }) => {
    if (keyCode === 27) {
      handleClose()
    } else if (keyCode === 37) {
      handlePreviousImage()
    } else if (keyCode === 39) {
      handleNextImage()
    }
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleButtonPressed)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleButtonPressed)
    }
  }, [handleButtonPressed])
  const node = useRef()
  const handleClick = e => node && node.current && !node.current.contains(e.target) && handleClose
  const handleClose = () => {
    setShowPopUp(false)
    setProjectArray(imagesArray?.slice(0, imagesToShow))
  }

  useEffect(() => {
    if (imagesArray) {
      setSelectedImage(selectedImage || imagesArray[0])
      setProjectArray(imagesArray?.slice(0, imagesToShow))
    }
  }, [imagesArray])
  const showGalleryArrows = imagesArray?.length > 1
  if (!showPopUp) return null

  const ModalTitle = isLearningPath
    ? `${Text.project} ${learningPathProjects.findIndex((project) => project.CourseId === selectedProject.CourseId) + 1}`
    : Text.courseProject

  const altImage = `${selectedImage?.Text} ${tags} `

  return (
    <>
      <Paper className={header}>
        <TypographyElement
          variant='heading4'
        >
          {ModalTitle}
        </TypographyElement>
        {showPricing
          ? <Button
              variation={isLearningPath ? ButtonVariation.confirmation : ButtonVariation.primary}
              size={ButtonSize.small}
              label={isLearningPath ? Text.accessTheLearningPath : Text.accessTheTraining}
              onHandleClick={() => {
                setShowPopUp(false)
                !isLearningPath && scrollToPricing()
              }}
            />
          : null}
      </Paper>
      <div className={gallery}>
        {showGalleryArrows && (
          <div className={arrowsContainer}>
            <IconButton
              iconName={Icons.play}
              className={buttonStyle}
              iconStyle={leftIcon}
              onHandleClick={handlePreviousImage}
            />
            <IconButton
              iconName={Icons.play}
              className={buttonStyle}
              onHandleClick={handleNextImage}
            />
          </div>
        )}
        <img
          src={selectedImage?.LargeImageLink}
          alt={altImage}
          className={bigImage}
        />
        <div className={projectPictures}>
          {
          projectArray?.map(project => {
            const altProject = project?.Text + ' ' + tags
            return (
              <img
                key={project.ImageId}
                src={project.SmallImageLink}
                alt={altProject}
                height={69}
                width={120}
                className={classNames(image, { [selectedImageStyle]: project.ImageId === selectedImage?.ImageId })}
                onClick={() => handleImageClick(project)}
              />
            )
          })
          }
        </div>
        <div className={projectText}>
          <TypographyElement
            variant='body1'
            color={theme.neutral[400]}
          >
            {selectedImage?.Text}
          </TypographyElement>
        </div>
      </div>
    </>
  )
}
